import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import CustomCard from '../../v2-components/Antd/Card';
import CustomLink from '../../v2-components/Antd/Link';
import CustomLinkOnCLick from '../../v2-components/Antd/LinkOnClick';
import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';
import { GetLocalStorageValue } from '../../_config/adapters/local-storage/get-local-storage-value.adapter';
import './style.scss';
import { ENVIROMENT } from '../../v2-config/constants/enviroment.constant';
import { Service } from './pages/magistral-formula/service';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LoadingPage from '../../v2-components/LoadingPage';
export default function ProfilePage() {
	const handleLogout = async () => {
		localStorage.removeItem(LOCAL_STORAGE.USER_TOKEN);
		localStorage.removeItem(LOCAL_STORAGE.USER_FAVORITES);
		localStorage.removeItem(LOCAL_STORAGE.USER_MAIN_INFO);
		localStorage.removeItem(LOCAL_STORAGE.CART);
		localStorage.removeItem(LOCAL_STORAGE.USER_EMAIL);
		window.location.href = '/';
	};

	useEffect(() => {
		window.scroll(0, 0);
	}, []);

	const { first_name } = GetLocalStorageValue('userMainInfo');
	const [isLoading, setIsLoading] = useState(true);
	const [magistralQuotation, setMagistralQuotation] = useState();
	const email = GetLocalStorageValue('userEmail');
	const location = useLocation();

	useEffect(() => {
		const page = 1;
		const payload = {
			page: page,
			country: Enviroment.COUNTRY,
			pharmacy: Enviroment.ROOT_PHARMACY,
			user_email: email,
		};
		new Service()
			.getMagistralQuotation(payload)
			.then((response) => {
				setMagistralQuotation(response.data);
				setIsLoading(false);
			})
			.catch((error) => {
				console.log(error);
			});
	}, [location.search, email]);

	if (isLoading) return <LoadingPage />;

	// console.log('magistralQuotation', magistralQuotation);

	return (
		<>
			<Row className="profile-content" justify="center">
				<Col span={22}>
					<Row justify="left">
						<CustomLink style={{ marginBottom: '10px' }} className={'link-primary'} to="/">
							¡Hola {first_name}, te damos la bienvenida!
						</CustomLink>
					</Row>
					<Row justify="left">
						<CustomLink style={{ marginBottom: '10px' }} className={'link-primary'} to="/">
							Volver al inicio
						</CustomLink>
					</Row>
					<Row justify="left" gutter={[16, 16]}>
						<Col md={8} xs={24}>
							<CustomCard className={'card-primary'} title="Datos Personales">
								<p>Revisa y modifica tus datos personales.</p>
								<CustomLink className={'link-primary'} to="/profile-info/personal">
									Click Aqui
								</CustomLink>
							</CustomCard>
						</Col>
						<Col md={8} xs={24}>
							<CustomCard className={'card-primary'} title="Historial de Compras">
								<p>Revisa el estado de tus compras realizadas</p>
								<CustomLink className={'link-primary'} to="/profile-info/shopping-history">
									Click Aqui
								</CustomLink>
							</CustomCard>
						</Col>
						{ENVIROMENT.ROOT_PHARMACY !== 'jvf' && (
							<Col md={8} xs={24}>
								<CustomCard className={'card-primary'} title="Historial de cotizaciones">
									{magistralQuotation.length > 0 ? <p>Revisa las solicitudes de cotizaciones</p> : <p>Aún no has realizado cotizaciones.</p>}
									<CustomLink className={'link-primary'} to="/profile-info/magistral-formula">
										Click Aqui
									</CustomLink>
								</CustomCard>
							</Col>
						)}
						{ENVIROMENT.ROOT_PHARMACY === 'jvf' && (
							<Col md={8} xs={24}>
								<CustomCard className={'card-primary'} title="Historial de solicitudes">
									<p>Revisa el estado de tus solicitudes realizadas</p>
									<CustomLink className={'link-primary'} to="/profile-info/reserve-history">
										Click Aqui
									</CustomLink>
								</CustomCard>
							</Col>
						)}
						<Col md={8} xs={24}>
							<CustomCard className={'card-primary'} title="Modificar Contraseña">
								<p>Modifica tu contraseña cuando lo necesites</p>
								<CustomLink className={'link-primary'} to="/profile-info/change-password">
									Click Aqui
								</CustomLink>
							</CustomCard>
						</Col>
						<Col md={8} xs={24}>
							<CustomCard className={'card-primary'} title="Cerrar sesión">
								<p>¡Esperamos verte pronto!</p>
								<CustomLinkOnCLick className={'link-primary'} onClick={() => handleLogout()}>
									Cerrar sesión
								</CustomLinkOnCLick>
							</CustomCard>
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
}
